import { ActionContext } from "vuex"
import Service from "./service"

const getRoutes = async ({ commit }: any) => {
  return Service()
    .index()
    .then(async result => {
      await commit("save_routes", result.data)
      return result.data
    })
}

const addRoute = ({ commit, dispatch }: ActionContext<any, any>, data: any) => {
  commit("show_route", data)
  dispatch("routeItems/saveRouteItems", data.routeItems, { root: true })
}

const showRoute = async ({ dispatch }: ActionContext<any, any>, id: string) => {
  return Service().show(id)
}

const statusRoute = async ({ commit }: ActionContext<any, any>, obj: any) => {
  return Service()
    .status(obj)
    .then(() => {
      commit("update_status", obj)
    })
}

const activate = async (
  { commit }: ActionContext<any, any>,
  selected: Object[]
) => {
  return Service()
    .activateRoutes(selected)
    .then(() => {
      commit("activate_routes", selected)
    })
}

const disable = async (
  { commit }: ActionContext<any, any>,
  selected: Object[]
) => {
  return Service()
    .disableRoutes(selected)
    .then(() => {
      commit("disable_routes", selected)
    })
}

export default {
  getRoutes,
  showRoute,
  statusRoute,
  activate,
  addRoute,
  disable,
}
